// extracted by mini-css-extract-plugin
export default {"buttons":"PeopleNavigation_buttons__765cK","container":"PeopleNavigation_container__nl4fO"};